import { MobileHomeSegments } from "./MobileHomeSegments";
import { ShowIoSBannerField } from "./ShowIosBannerField";

interface DependentFieldsProps {
  iosAppEnabled: boolean;
  hasBrandedApp: boolean;
}
export const DependentFields = ({
  iosAppEnabled,
  hasBrandedApp,
}: DependentFieldsProps) => {
  if (!iosAppEnabled && !hasBrandedApp) {
    return null;
  }

  if (iosAppEnabled && hasBrandedApp) {
    return <ShowIoSBannerField />;
  }

  return (
    <div className="bg-tertiary mt-6 rounded-lg px-6 py-5">
      <MobileHomeSegments />
      <ShowIoSBannerField />
    </div>
  );
};
